import { render, staticRenderFns } from "./UserReferrals.vue?vue&type=template&id=707c615f"
import script from "./UserReferrals.vue?vue&type=script&lang=js"
export * from "./UserReferrals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports